<template>
	<div class='story' >
		
		<div class="knd-lead">

			<Toggle 
				:value="lang !== 'nl'" 
				:buttonFill='"#4D00FF"' 
				:buttonStroke='"#4e243F"' 
				:colorLinks='"#4D00FF"'
				:colorRechts='"#4D00FF"' 
				:toggleFn='switchToggle'
			>

				<template #links>
					NL
				</template>
				
				<template #rechts>
					EN
				</template>
			</Toggle>

			<p v-html="getContent(content.intro)"></p>
		</div>
	</div>
</template>

<script>
import Toggle from './components/toggle';

import './scss/index.scss'
import './app.scss';

export default {
	name: 'App',
	data() {
		return {
			content: this.$store.state.content,
			lang: this.$store.state.language
		}
	},
	mounted: function() {},
	methods: {
		getContent(obj) {
			if (this.$store.state.language === "nl") {
				return obj.data;
			}
			else {
				return obj.data5891;	
			}
		},

		switchToggle() {
			this.$store.commit('switchLanguage');
		}
	},
	components: {
		Toggle
	}
}
</script>
